"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnscreenMessage = function OnscreenMessage(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M18 7H6C5.86739 7 5.74021 7.05268 5.64645 7.14645C5.55268 7.24021 5.5 7.36739 5.5 7.5V16.5C5.49995 16.5657 5.51285 16.6307 5.53796 16.6914C5.56307 16.7521 5.59989 16.8072 5.64633 16.8537C5.69277 16.9001 5.74791 16.9369 5.8086 16.962C5.86928 16.9872 5.93432 17.0001 6 17H18C18.1326 17 18.2598 16.9473 18.3536 16.8536C18.4473 16.7598 18.5 16.6326 18.5 16.5V7.5C18.5 7.36739 18.4473 7.24021 18.3536 7.14645C18.2598 7.05268 18.1326 7 18 7Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 9.5H8C7.86739 9.5 7.74021 9.44732 7.64645 9.35355C7.55268 9.25979 7.5 9.13261 7.5 9C7.5 8.86739 7.55268 8.74021 7.64645 8.64645C7.74021 8.55268 7.86739 8.5 8 8.5H15C15.1326 8.5 15.2598 8.55268 15.3536 8.64645C15.4473 8.74021 15.5 8.86739 15.5 9C15.5 9.13261 15.4473 9.25979 15.3536 9.35355C15.2598 9.44732 15.1326 9.5 15 9.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 11.5H8C7.86739 11.5 7.74021 11.4473 7.64645 11.3536C7.55268 11.2598 7.5 11.1326 7.5 11C7.5 10.8674 7.55268 10.7402 7.64645 10.6464C7.74021 10.5527 7.86739 10.5 8 10.5H14C14.1326 10.5 14.2598 10.5527 14.3536 10.6464C14.4473 10.7402 14.5 10.8674 14.5 11C14.5 11.1326 14.4473 11.2598 14.3536 11.3536C14.2598 11.4473 14.1326 11.5 14 11.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16 13.5H8C7.86739 13.5 7.74021 13.4473 7.64645 13.3536C7.55268 13.2598 7.5 13.1326 7.5 13C7.5 12.8674 7.55268 12.7402 7.64645 12.6464C7.74021 12.5527 7.86739 12.5 8 12.5H16C16.1326 12.5 16.2598 12.5527 16.3536 12.6464C16.4473 12.7402 16.5 12.8674 16.5 13C16.5 13.1326 16.4473 13.2598 16.3536 13.3536C16.2598 13.4473 16.1326 13.5 16 13.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13 15.5H8C7.86739 15.5 7.74021 15.4473 7.64645 15.3536C7.55268 15.2598 7.5 15.1326 7.5 15C7.5 14.8674 7.55268 14.7402 7.64645 14.6464C7.74021 14.5527 7.86739 14.5 8 14.5H13C13.1326 14.5 13.2598 14.5527 13.3536 14.6464C13.4473 14.7402 13.5 14.8674 13.5 15C13.5 15.1326 13.4473 15.2598 13.3536 15.3536C13.2598 15.4473 13.1326 15.5 13 15.5Z",
    fill: props.foregroundColor
  }));
};

OnscreenMessage.defaultProps = {
  altText: "Onscreen Message",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
OnscreenMessage.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = OnscreenMessage;
exports.default = _default;